/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';
import {
    type PaymentSummaryDto,
    PaymentSummaryDtoFromJSON,
    PaymentSummaryDtoToJSON,
} from '../models/PaymentSummaryDto';

export interface GetPaymentSummaryRequest {
    from: Date;
    to: Date;
}

/**
 * 
 */
export class PaymentSummaryControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for getPaymentSummary without sending the request
     */
    async getPaymentSummaryRequestOpts(requestParameters: GetPaymentSummaryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['from'] == null) {
            throw new runtime.RequiredError(
                'from',
                'Required parameter "from" was null or undefined when calling getPaymentSummary().'
            );
        }

        if (requestParameters['to'] == null) {
            throw new runtime.RequiredError(
                'to',
                'Required parameter "to" was null or undefined when calling getPaymentSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = (requestParameters['from'] as any).toISOString();
        }

        if (requestParameters['to'] != null) {
            queryParameters['to'] = (requestParameters['to'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/payment-summary`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentSummaryRaw(requestParameters: GetPaymentSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentSummaryDto>> {
        const requestOptions = await this.getPaymentSummaryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentSummaryDtoFromJSON(jsonValue));
    }

    /**
     */
    async getPaymentSummary(requestParameters: GetPaymentSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentSummaryDto> {
        const response = await this.getPaymentSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
